import { useTranslation } from "react-i18next"

import { ProductSheetLanguages } from "@tfg/types/constants/language.constants"
import {
  ProductSheetLanguageSchema,
  ProductSheetLanguage,
} from "@tfg/types/schemas/languages"

export const useGetCurrentLanguage = () => {
  const { i18n } = useTranslation()
  const language = i18n.language
  const parsedProdcutSheetLanguage = ProductSheetLanguageSchema.safeParse(
    language.toLocaleUpperCase() as ProductSheetLanguage
  )
  if (!parsedProdcutSheetLanguage.success) {
    return ProductSheetLanguages.EN
  }
  return parsedProdcutSheetLanguage.data
}
